import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{
    padding: "20px 0 0 0",
    borderRadius: "12px",
    position: 'relative',
    left: "10px",
    top: "4px",
  },
  title: {
    color: "white",
    marginLeft: "10px",
    fontSize: "22px !important",
    fontWeight: 600,
  },
  adminIconWrapper: {
    borderRadius: "50%",
    border: "2px solid white",
    backgroundColor: theme.palette.primary.primary200,
    maxWidth: "30px !important",
    width: "30px",
    minWidth: "30px",
    height: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "32px",
  },
  headerWrapper: {
    backgroundImage: "url('/img/background/bg-aprovall.png')",
    backgroundPosition: "bottom right",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    width: "100%",
    height: "107px",
    position: "relative",
    top: "-1rem",
    borderRadius: "12px",
    paddingTop: ".5rem",
    "& + div": {
      top: "-45px",
    },
  },
  headerContent: {
    position: "relative",
    bottom: "50px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    zIndex: 5
  },
  mainContentWrapper:{
    position: "relative",
    top: "-3.5rem",
  },
  // Tab
  tab: {
    fontWeight: 600,
    borderRadius: '18px 18px 0 0',
    minWidth: "38px",
    height: "25px",
    marginRight: "2px",
    backgroundColor: "white",
    zIndex: 1,
    position: "relative",
    bottom: "-10px",
    textTransform: "none",
  },
  selectedTab: {
    color: "black !important",
  },
  unselectedTab: {
    opacity: .75,
  },
  tabsWrapper: {
    border: "none",
    borderBottom: 1,
    borderColor: 'divider',
  },
  tabContentWrapper: {
    backgroundColor: theme.palette.background.white,
    borderRadius: "0 12px 12px 12px",
  },
  // appBar
  appBar:{
    height: "64px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
    position: "relative",
    top: "-1rem",
    left: "10px",
  },
  backToHome: {
    cursor: "pointer",
    color: theme.palette.primary.primary100,
    fontWeight: 700,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: ".5rem",
    textDecoration: "none",
    marginLeft: ".5rem",
  },
  tabDisabled: {
    opacity: 0.75,
    background: "#E2E2EABF",
  },
}));

export default useStyles;
